module.exports = __webpack_public_path__ + "media/country_flags/is-aad28925.png";